export const ROLES = {
  ADMIN: "admin",
  SHOWROOM: "showroom",
  FACTORY: "factory",
};